// コーチ確認完了後60日で記録を purge したセッションの定型表示。
// backend の SESSION_PURGED_MESSAGE (src/api/routes/sessions.py) と文言を揃える。
export const SESSION_PURGED_MESSAGE = 'コーチ確認完了後60日が経過したため削除されました';
